import { useState } from 'react'

import CardComponent from '@/components/CardComponent'

import EmiBreakdownModal from '../EmiBreakdownModal'
import EmiScheduleItem from '../EmiScheduleItem'

const EmiScheduleList = ({ data }) => {
  const [selectedItem, setSelectedItem] = useState(null)

  const items = data?.components?.items || []

  const handleSeeBreakdown = item => {
    console.log('item', item)
    setSelectedItem(item)
  }

  const handleCloseModal = () => {
    setSelectedItem(null)
  }

  return (
    <div className='ew-px-16 ew-mt-16'>
      <CardComponent className='ew-py-0'>
        {items.map((item, index) => (
          <EmiScheduleItem
            data={item}
            isLast={index === items.length - 1}
            key={`${item.emi_date}-${index}`}
            onSeeBreakdown={handleSeeBreakdown}
          />
        ))}
      </CardComponent>

      <EmiBreakdownModal data={selectedItem} onClose={handleCloseModal} show={!!selectedItem} />
    </div>
  )
}

export default EmiScheduleList
